import Axios from "axios";
import {
  SET_EMPLOYEE_WEEKEND_LIST,
  UNSET_EMPLOYEE_WEEKEND_LIST,
} from "@/store/mutation-types";
import {
  getEmployeeWeekendList,
  saveUpdateEmployeeWeekend,
  getEmployeeWeekendDetails,
} from "@/store/api";

const state = {
  employeeWeekendList: [],
  employeeWeekendDetails: null,
};

const getters = {
  getEmployeeWeekendList(state) {
    return state.employeeWeekendList;
  },
  getEmployeeWeekendDetails(state) {
    return state.employeeWeekendDetails;
  },
};

const mutations = {
  [SET_EMPLOYEE_WEEKEND_LIST](state, data) {
    state.employeeWeekendList = data || [];
  },
  [UNSET_EMPLOYEE_WEEKEND_LIST](state) {
    state.employeeWeekendList = [];
  },
  setEmployeeWeekendDetails(state, data) {
    state.employeeWeekendDetails = data;
  },
  unsetEmployeeWeekendDetails(state) {
    state.employeeWeekendDetails = null;
  },
};

const actions = {
  saveUpdateEmployeeWeekend({ commit }, payload) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateEmployeeWeekend, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getEmployeeWeekendList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      Axios.post(getEmployeeWeekendList, payload)
        .then((response) => {
          commit(SET_EMPLOYEE_WEEKEND_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_WEEKEND_LIST);
          reject(error);
        });
    });
  },

  getEmployeeWeekendDetails({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(getEmployeeWeekendDetails(id))
        .then((response) => {
          commit("setEmployeeWeekendDetails", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit("unsetEmployeeWeekendDetails");
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

